import { vendorInitials } from "../lib/format";
import { resolveCompanyLogo, resolveModelCardLogo } from "../lib/brand-logo";

interface VendorMarkProps {
  company: string;
  large?: boolean;
  modelName?: string;
  modelFamily?: string;
  // One company key, or the organization fallback chain (own organization
  // first, then each parent) from `organizationLogoCompanies`.
  organizationLogoCompany?: string | readonly string[];
}

export function VendorMark({
  company,
  large = false,
  modelName,
  modelFamily,
  organizationLogoCompany
}: VendorMarkProps) {
  const fallbackCompanies =
    organizationLogoCompany === undefined
      ? []
      : typeof organizationLogoCompany === "string"
        ? [organizationLogoCompany]
        : organizationLogoCompany;
  const suppliedIconUrl = modelName
    ? resolveModelCardLogo(
        { company, name: modelName, family: modelFamily },
        fallbackCompanies
      )
    : resolveCompanyLogo(company) ??
      fallbackCompanies.map(resolveCompanyLogo).find(Boolean) ??
      null;

  return (
    <span
      className={`vendor-mark${large ? " vendor-mark--large" : ""}`}
      aria-hidden="true"
      title={company}
    >
      {suppliedIconUrl ? (
        <img
          src={suppliedIconUrl}
          alt=""
          loading="lazy"
          decoding="async"
        />
      ) : (
        vendorInitials(company)
      )}
    </span>
  );
}
